import React, { Component } from 'react';
import LazyLoad from 'react-lazyload';
import { connect } from 'react-redux';
import Asset from './Asset';

import { getWindowWidth } from '../../store/selectors/ui.selectors';

import SliderContainer, { Slide } from './Slider';

class ThreePointBox extends Component {
  renderPoints() {
    const { points } = this.props;

    return points && points.length > 0 && points.map(({
      icon,
      header,
      copy,
      images = [],
    }, i) => (
      <Slide key={i}>
        <div className="info-point">
          {icon && (
            <LazyLoad height="100%">
              <i className={icon}/>
            </LazyLoad>
          )}
          {images.length > 0 && (
            <Asset
              imageClassName="info-image"
              asset={images[0]}
            />
          )}
          <p className="info-point-copy">
            {header && (
              <span className="point-span-header">
                {header}
              </span>
            )}
            {copy}
          </p>
        </div>
      </Slide>
    ));
  }

  render() {
    const {
      anchor,
      background,
      className,
      header,
      points,
      windowWidth,
      disableInfiniteSlider,
    } = this.props;
    const mobile = windowWidth < 640;

    return (
      <section id={anchor || undefined} className={`three-points ${background || ''} ${className || ''}`}>
        {header && (
          <h2 className="three-points-title h2">
            {header}
          </h2>
        )}
        {points && (
          <div className="three-points-info">
            {mobile ? (
              <SliderContainer
                className="three-points__slider"
                slidesPerView={1}
                disableInfinite={disableInfiniteSlider}
              >
                {this.renderPoints()}
              </SliderContainer>
            ) : (
              <>
                {this.renderPoints()}
              </>
            )}
          </div>
        )}
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  windowWidth: getWindowWidth(state),
});

export default connect(mapStateToProps, {})(ThreePointBox);
